var map = {
	"./goldcoin/index-icon-big-coin.png": 26993,
	"./memetown/index-icon-big-coin.png": 50723,
	"./reflection/index-icon-big-coin.png": 34844,
	"./tapcoin/index-icon-big-coin.png": 57569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15545;